import { jsx as _jsx } from "react/jsx-runtime";
import { CatUtilityNavItem } from '@blocks-react/components/UtilityNavItem';
import cx from 'classnames';
import styles from './HeaderNavItem.module.scss';
export const HeaderNavItem = ({ children, classname, ...props }) => {
    return (_jsx(CatUtilityNavItem, { ...props, hideText: true, children: _jsx("div", { slot: "before", className: cx(classname ?? '', styles['header__nav-item']), children: children }) }));
};
